export default "__VITE_ASSET__DJ5wl4nZ__"